import { api } from './api';

const containerAPI = {
  getPorts: () => api.get('/containers/ports'),
  getAll: (companyId) => api.get(`/containers?companyId=${companyId}`),
  getByNumber: (containerNumber) => api.get(`/containers/${containerNumber}`),
  create: (container) => api.post('/containers', container),
  update: (containerNumber, container) => api.put(`/containers/${containerNumber}`, container),
  delete: (containerNumber, companyId) => api.delete(`/containers/${containerNumber}?companyId=${companyId}`),
  getReport: (companyId) => api.get(`/containers/report?companyId=${companyId}`),
  getStats: (companyId) => api.get(`/containers/stats?companyId=${companyId}`),
  bulkUpload: (formData) => api.post('/containers/bulk-upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),

  // Fetch container status options from backend
  getStatusOptions: () => api.get('/containers/container-status-options')
};

export default containerAPI;